import { Provider } from '../components/Providers';

/**
 * Static configuration for API providers
 * Add or modify providers directly in this file
 */
export const providers: Provider[] = [
    {
        id: 'groq',
        name: 'Groq',
        apiKey: process.env.REACT_APP_GROQ_API_KEY || '',
        description: 'High-performance AI API',
        isDefault: true
    },
    {
        id: 'openai',
        name: 'OpenAI',
        apiKey: process.env.REACT_APP_OPENAI_API_KEY || '',
        baseUrl: 'https://api.openai.com/v1',
        description: 'ChatGPT and GPT models'
    },
    {
        id: 'anthropic',
        name: 'Anthropic',
        apiKey: process.env.REACT_APP_ANTHROPIC_API_KEY || '',
        baseUrl: 'https://api.anthropic.com',
        description: 'Claude models'
    },
    {
        id: 'mistral',
        name: 'Mistral',
        apiKey: process.env.REACT_APP_MISTRAL_API_KEY || '',
        baseUrl: 'https://api.mistral.ai/v1',
        description: 'Mistral AI models'
    },
    {
        id: 'gemini',
        name: 'Google Gemini',
        apiKey: process.env.REACT_APP_GEMINI_API_KEY || '',
        baseUrl: 'https://generativelanguage.googleapis.com',
        description: 'Google\'s Gemini models'
    }
];

/**
 * Get a provider by ID
 */
export const getProviderById = (id: string): Provider | undefined => {
    return providers.find(provider => provider.id === id);
};

/**
 * Get the default provider
 */
export const getDefaultProvider = (): Provider => {
    return providers.find(provider => provider.isDefault) || providers[0];
}; 